export default __webpack_public_path__ + "static/media/img_ecs-colorBkg.7804fa34.png";